import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ResigteringService {
  constructor(private _HttpClient: HttpClient) {}

  user_Resigter(Data: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/register`, Data);
  }
  editUser(id:any,Data: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/update/user/${id}`, Data);
  }


  verificationCode(verification_code: string): Observable<any> {
    var obj = {
      verification_code: verification_code.toString(),
      email: sessionStorage.getItem('email')?.toString(),
    };
    return this._HttpClient.post(
      `${environment.Server_URL}/verify-code`,
      obj
    );
  }

  SkipVerificationCode(): Observable<any> {
    var obj = {

      email: sessionStorage.getItem('email')?.toString(),
    };
    return this._HttpClient.post(
      `${environment.Server_URL}/skip`,
      obj
    );
  }

  resendOTP() {
    var obj = {
      email: sessionStorage.getItem("email"),
    };
    return this._HttpClient.post(
      environment.Server_URL + `api/Authentication/ResendOTP?email=${obj.email}`,
      {}
    );
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

}
